// typesafe empty check
export const isEmpty = array => array instanceof Array && array.length === 0
